export default "__VITE_ASSET__B1Lg2qb9__"